import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import moment from 'moment';
import 'moment/locale/es';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ToastsComponent } from './components/toasts/toasts.component';

moment.locale('es');

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SpinnerComponent, ToastsComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
